import axios from 'axios'

const gerarCookieTokenCsrf = async () => {
  try {
    await axios.get('/csrf-token')
  } catch (e) {
    console.log(e)
    throw e
  }
}

export default {
  gerarCookieTokenCsrf
}
